import axios from 'axios'

export type ApiResponse<T> = T & {
  success: boolean
  errorMessage?: string
}

export const apiClient = axios.create({ baseURL: `/api/organizations` })
